import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { Oferent } from 'app/model/oferent';
import { CenaMontazu } from 'app/model/cena';
import { of } from 'rxjs/observable/of';

@Injectable()
export class MontagePriceService {

  PRICES: Array<CenaMontazu> = [];

  constructor(public af: AngularFireDatabase) {
    this.reloadFromDb();
  }

  reloadFromDb(): void {
    this.af.list('/ceny_montazu').snapshotChanges().subscribe(action => {
      this.PRICES = [];

      action.forEach(a => {
        const val = a.payload.val();
        const montage_price = new CenaMontazu();
        montage_price.id = a.payload.key;

        montage_price.cena = val.cena;
        montage_price.dostawca_id = val.dostawca_id;
        montage_price.moc_do = val.moc_do;
        montage_price.moc_od = val.moc_od;
        montage_price.confirmed = val.confirmed ? true : false;

        this.PRICES.push(montage_price);
      });
    });
  }


  getPrices(offerId: string) {

    const prices: Array<CenaMontazu> = [];
    if (offerId === undefined) {
      return  prices;
    }

    for (const pr of this.PRICES) {
      if (pr.dostawca_id === offerId) {
        prices.push(pr);
      }
    }
    return prices;
  }

  save(montage_price: CenaMontazu) {
    const data = {
      cena: montage_price.cena,
      dostawca_id: montage_price.dostawca_id,
      moc_do: montage_price.moc_do,
      moc_od: montage_price.moc_od,
      confirmed: montage_price.confirmed
    };

    if (!montage_price.id) {
      this.af.list('/ceny_montazu/').push(data);
    } else {
      this.af.object('/ceny_montazu/' + montage_price.id).update(data);
    }
  }

  delete(id: string): void {
    this.af.object('/ceny_montazu/' + id).remove()
      .then(a => {
        console.log('Deleted');
      });
  }

  // getOffer(id: string): Observable<Oferent> {
  //   return of(this.OFFERS.find(oferent => oferent.id === id));
  // }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/montage-price.service.ts